package com.anjuros.website.templates.template9.sections

import com.anjuros.website.templates.template9.components.Template9Reveal
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.remember
import com.anjuros.website.templates.template9.components.Template9FAQCard
import com.anjuros.website.templates.template9.components.Template9SectionTitle
import com.anjuros.website.templates.template9.modules.Template9FAQ
import com.anjuros.website.templates.template9.modules.Template9Section
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9SectionPaddingStyle
import com.anjuros.website.templates.template9.util.ResKey
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun Template9FAQSection() {

    val expanded = remember {
        mutableStateListOf<Boolean>().apply {
            repeat(Template9FAQ.entries.size) { add(false) }
        }
    }

    Column(
        modifier = Template9SectionPaddingStyle.toModifier()
            .id(Template9Section.FAQ.id)
            .fillMaxWidth()
            .backgroundColor(Template9Theme.Background.rgb),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Template9Reveal(
            modifier = Template9ContainerStyle.toModifier(),
            contentAlignment = Alignment.TopCenter
        ) {
            Template9SectionTitle(
                eyebrow = ResKey.TEMPLATE9_FAQ_EYEBROW,
                title = ResKey.TEMPLATE9_FAQ_TITLE
            )
        }

        SimpleGrid(
            numColumns = numColumns(base = 1, lg = 2),
            modifier = Template9ContainerStyle.toModifier()
                .maxWidth(980.px)
                .margin(top = 40.px)
                .gap(16.px)
                .styleModifier { property("align-items", "start") }
        ) {
            Template9FAQ.entries.forEach { faq ->
                Template9Reveal(
                    modifier = Modifier.fillMaxWidth(),
                    delayMs = (faq.ordinal / 2) * 100,
                    offsetY = 20
                ) {
                    Template9FAQCard(
                        faq = faq,
                        expanded = expanded[faq.ordinal]
                    ) {
                        expanded[faq.ordinal] = !expanded[faq.ordinal]
                    }
                }
            }
        }
    }
}
